import { createFileRoute } from '@tanstack/react-router'

import { FeatureNotAvailable } from '@/components/feature-not-available'

export const Route = createFileRoute('/_authenticated/_general/marketing/journeys')({
	component: JourneysPage,
	staticData: {
		crumb: ({ context: { L } }) => L.Marketing.Journeys()
	}
})

function JourneysPage() {
	return <FeatureNotAvailable />
}
